export const hasHistory = (): boolean => {
  return window.history.state && window.history.state.idx > 0;
};
